/** Get array value with cycling (modulo), or fallback default */
export function getCyclic(arr: any[], index: number, defaultVal: number): number {
  if (!Array.isArray(arr) || arr.length === 0) return defaultVal;
  return arr[index % arr.length] ?? defaultVal;
}

/** Pick a cycling element from an array, or return a scalar unchanged */
export function pickCyclic<T>(value: T | T[], index: number): T {
  return Array.isArray(value) ? value[index % value.length] : value;
}
